import { createStyledContext } from "../helpers/createStyledContext.mjs";
const ComponentContext = createStyledContext({
  disableSSR: void 0,
  inText: !1,
  language: null,
  animationDriver: null,
  setParentFocusState: null
});
export { ComponentContext };
//# sourceMappingURL=ComponentContext.mjs.map
